import React from "react";
import { Typography, Grid } from "@mui/material";
import { Link, Edit } from "@mui/icons-material";
import { IconButton, Skeleton } from "@mui/material";

const iconStyle = {
  position: "absolute",
  left: -40,
  top: 14,
};

export default function InfoField({
  label,
  value,
  onNavigate,
  onEdit,
  fontSize,
  md,
  loading,
}) {
  return (
    <Grid
      item
      display="flex"
      position="relative"
      flexDirection="column"
      textAlign="left"
      md={md ?? 2}
      sm={4}
      xs={12}
    >
      {onNavigate != null ? (
        <IconButton onClick={onNavigate} sx={iconStyle}>
          <Link color="primary" />
        </IconButton>
      ) : null}
      {onEdit != null ? (
        <IconButton size={"12"} onClick={onEdit} sx={iconStyle}>
          <Edit color="primary" />
        </IconButton>
      ) : null}
      <Typography fontSize={fontSize != null ? fontSize : 12}>
        {label}
      </Typography>
      <Typography
        fontSize={fontSize != null ? fontSize : 16}
        textOverflow={"ellipsis"}
        overflow={"hidden"}
        title={value}
        color={"black"}
      >
        {loading ? <Skeleton height={34} /> : value ? value : "-"}
      </Typography>
    </Grid>
  );
}
